import React, { Component } from 'react';
import { canUseDOM } from 'exenv';
import Cookies from 'js-cookie';
import isUndefined from 'lodash/isUndefined';

export default class PrivacyPolicyPopup extends Component {
  constructor(props) {
    super(props);

    this.dismiss = this.dismiss.bind(this);

    if (canUseDOM && isUndefined(localStorage.incPrivacyPopupDisplay)) {
      localStorage.setItem('incPrivacyPopupDisplay', 'true');
    }
  }

  componentDidMount() {
    if (isUndefined(Cookies.get('usprivacy'))) {
      Cookies.set('usprivacy', '1YNY', { expires: 100000 });
    }
  }

  dismiss() {
    localStorage.setItem('incPrivacyPopupDisplay', 'false');
    this.forceUpdate();
  }

  render() {
    if (
      canUseDOM &&
      localStorage.getItem('incPrivacyPopupDisplay') === 'true'
    ) {
      return (
        <dialog className="privacyPolicyPopup">
          <div className="popupMessage">
            <strong>
              We updated our Privacy Policy as of February 24, 2020.
            </strong>{' '}
            Learn about our 
            <a
              href="//mansueto.com/privacy-policy#collection"
              rel="noopener noreferrer"
              target="_blank"
            >
             personal information collection practices{' '} here
            </a>.
          </div>

          <div
            className="closeButton"
            onClick={() => {
              this.dismiss();
            }}
          >
            <img
              src="//mansuetofiles.com/FastCompany/privacy-popup-close-button.svg"
              alt="X"
            />
          </div>
        </dialog>
      );
    }
    return false;
  }
}
